import { ICommonLink } from '@src/models/common';

export const EVENT: ICommonLink = {
  id: 'event',
  disableNextJs: true,
  href: '/event',
  name: 'Афиша мероприятий',
};
